<script>
	// Stores 
	import { 
		textSite,
	} from '../store.js';  

	// Componentes
	import PageHeader                       from './../components/PageHeader.svelte';
	import { Router, Link, link , Route }   from "svelte-routing";
	import { fade, fly }                    from 'svelte/transition';
	import { quintOut }                     from 'svelte/easing';    

	// Code
	let titlePage = 'Seguro Conteúdo';
</script>

<section class="conteudo-internas">
	<PageHeader title={titlePage}></PageHeader>
	<div class="container clearfix text-justify">
		<p>A nossa experiência de mais de 30 anos formatou um seguro que traz enorme tranquilidade a quem aluga um imóvel com a gente, e também para condôminos ou ocupantes de unidades em prédios administrados pela Dinmar.</p>
		<p>Diferente do seguro obrigatório contra incêndios para condomínios, que cobre a recuperação do imóvel, o Seguro Conteúdo Dinmar protege os móveis e utensílios, tanto de pessoa física quanto jurídica.</p>
		<p>Pense no custo da reposição da sua mobília, ou seus equipamentos: pois você não precisa mais se preocupar com isso. O custo dessa facilidade é baixíssimo, cobrado junto com o aluguel.</p>
		<p>E se você não desejar contar mais com essa cobertura, basta um telefonema ou e-mail para que a cobrança seja interrompida. Sem burocracia para contratar, sem burocracia para descontratar.</p>
	</div>
</section>